export const firebaseConfig = {
  apiKey: "AIzaSyAgCjHfp8PJ7AUDuMHi4zRQwZW-xdnQ10E",
  authDomain: "wavelength-online-r.firebaseapp.com",
  databaseURL: "https://wavelength-online-r-default-rtdb.firebaseio.com",
  projectId: "wavelength-online-r",
  storageBucket: "wavelength-online-r.firebasestorage.app",
  messagingSenderId: "789419722246",
  appId: "1:789419722246:web:70147eb504ea1972f0e587",
  measurementId: "G-WV70SHT8S3"
};